import React from 'react';
import styled from 'styled-components/macro';

import Box from '../Box';

const BBox = styled(Box)`
  position: relative;
  display: inline-block;
`;

const SelectWrapper = ({ children, ...rest }) => {
  return <BBox {...rest}>{children}</BBox>;
};

SelectWrapper.displayName = 'SelectWrapper';

export default SelectWrapper;
